import CompanyDetails from "../../../../components/units/Management/Company/Details";

export default function CompanyDetailsPage() {
  return <CompanyDetails />;
}
